import { monthIndex } from "@/mocks/home";
import Reveal from "./Reveal";

export default function ArchiveIndex() {
  return (
    <section id="index" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 border-b border-background-200 pb-6">
          <div>
            <span className="text-xs tracking-[0.3em] text-secondary-500 uppercase">Index</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              年月归档索引
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base leading-7 text-foreground-700">
              记得大概时间但不记得具体事件？直接从年月索引进去，比按热度翻更快找到那段记录。
            </p>
          </div>
          <span className="text-xs text-foreground-500 whitespace-nowrap">
            共 6 个年度分区 · 28 个月份
          </span>
        </div>

        <div className="mt-8 flex flex-col divide-y divide-background-100">
          {monthIndex.map((group, index) => (
            <Reveal
              key={group.year}
              delay={index * 50}
              className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-6 py-5"
            >
              <div className="md:col-span-2">
                <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {group.year}
                </span>
                <span className="block text-[11px] text-foreground-500 mt-0.5">
                  {group.months.length} 个分区
                </span>
              </div>
              <div className="md:col-span-10 flex flex-wrap gap-2">
                {group.months.map((month) => (
                  <a
                    key={`${group.year}-${month}`}
                    href="#index"
                    className="h-9 px-4 rounded-md border border-background-300 text-xs text-foreground-700 hover:border-primary-400 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer flex items-center"
                  >
                    {month === group.year ? `${month} 年度` : `${month} 月`}
                  </a>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}